import { get } from "lodash/fp";

export const sortSelectStyle = {
  width: "230px",
  borderRadius: "999px",
  border: "2px solid #f3AA44",
  color: "#5a5a5a",
  fontWeight: 600,
};

export const getJoinTimestamp = (eventUser) => {
  const joinDate = get("createdAt", eventUser);
  const timestamp = Date.parse(joinDate);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const sortUsers = (users, order) =>
  [...users].sort((firstUser, secondUser) => {
    const firstJoinTime = getJoinTimestamp(firstUser);
    const secondJoinTime = getJoinTimestamp(secondUser);

    if (order === "earliest") {
      return firstJoinTime - secondJoinTime;
    }
    return secondJoinTime - firstJoinTime;
  });

export const filterAndSortUsers = (allUsers, value, order, searchList) => {
  const filteredUsers = value ? searchList(allUsers, value) : allUsers;
  return sortUsers(filteredUsers, order);
};

export const formatJoinedAt = (joinDate) => {
  if (!joinDate) {
    return "N/A";
  }

  const parsedDate = new Date(joinDate);
  if (Number.isNaN(parsedDate.getTime())) {
    return "N/A";
  }

  return parsedDate.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
